import dynamic from 'next/dynamic';

import { SectionTitleBlockProps } from '../../../components/blocks/SectionTitleBlock';
import { ContentBlockRenderer } from '../../../types/Block';
import { Transformer } from '../../../types/Transformer';
import { SectionTitleContentSection } from './types';

/* istanbul ignore next */
export const renderer: ContentBlockRenderer<SectionTitleBlockProps> =
  dynamic<SectionTitleBlockProps>(() =>
    import('src/components/blocks/SectionTitleBlock').then((mod) => mod.SectionTitleBlock),
  );

export const transformer: Transformer<SectionTitleContentSection, SectionTitleBlockProps> = (
  { title, _metadata },
  { pageConfig, positionMetadata },
) => ({
  uid: _metadata.uid,
  props: {
    title,
    headingIsPageTitle: positionMetadata.position === 0 && pageConfig.pageType !== 'homepage',
  },
});
